/**
 * The browser events between a feature package and the shell's Player AI
 * panel.
 *
 * A BROWSER EVENT rather than an imported callback, for the reason
 * `onboarding-tour.ts` gives: features never import the shell, and the shell
 * never imports a feature (ADR-0009). Only the NAMES and the payload SHAPES
 * live here, so both sides compile against one contract; the dispatch is the
 * caller's own `window.dispatchEvent`, because this package is compiled
 * without the DOM lib and is imported by `services/*`.
 */
export const PLAYER_AI_OPEN_EVENT = "playerai:open";
/** The shell's answer to an `open` that asked to send. */
export const PLAYER_AI_SEND_RESULT_EVENT = "playerai:send-result";
export const PLAYER_AI_SEND_FAILURE_REASONS = [
    /** Not sent within 60 seconds of the click. */
    "timeout",
    /** A card in this private chat still waits for approval. */
    "card_waiting",
    /** The person left that workspace before the message was sent. */
    "workspace_changed",
    /** The person may not post in this chat. */
    "not_allowed",
    /** The send itself failed. */
    "send_failed",
];
//# sourceMappingURL=player-ai-events.js.map